import axios from "axios";

import ENV from "@config/env";
import { interceptRequest, interceptResponse } from "@utils/interceptors";

axios.defaults.baseURL = ENV.API_HOST;

axios.interceptors.request.use(interceptRequest);
axios.interceptors.response.use(interceptResponse);

export default class BaseService {
  entity: any;
  create(data: any) {
    const headers = this.getHeaders();
    return axios.post(this.entity, data, { headers });
  }

  update(id: string, data: any) {
    const headers = this.getHeaders();
    return axios.put(`${this.entity}/${id}`, data, { headers });
  }

  delete(id: string) {
    const headers = this.getHeaders();
    return axios.delete(`${this.entity}/${id}`, { headers });
  }

  async getAll(params = {}) {
    const headers = this.getHeaders();
    return await axios.get(this.entity, { headers, params });
  }

  async getOne(id: string) {
    const headers = this.getHeaders();
    const item = await axios.get(`${this.entity}/${id}`, { headers });
    return item;
  }

  async getOneByIdAndCompany(id: string, companyName: string) {
    const headers = this.getHeaders();
    const item = await axios.get(`${this.entity}/${companyName}/${id}`, {
      headers,
    });
    return item;
  }

  getHeaders() {
    const token = localStorage.getItem("token");

    if (!token) return {};

    return { Authorization: `Bearer ${token}` };
  }
}
